import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import PaymentProcessingPage from "../../payment-processing/PaymentProcessingPage"
import { PAYMENT_ACCOUNT_STATUS } from "../../utils"
import PaymentAccountService from "./../../payment-account/service/paymentAccountService"

type OwnProps = {
    session_key: string,
    merchant_id : string,
    merchant_application_id : string
}


const RainforestOnboardingMerchantWrapper =  (props: OwnProps) => {

    const [isSubmitted, setIsSubmitted] = useState<boolean>(false)


    useEffect(() => {
        const component = document.querySelector("rainforest-merchant-onboarding")
        if (component) {
            component.addEventListener("submitted", handleSubmitted)
        }

        return () => {
            if (component) {
                component.removeEventListener("submitted", handleSubmitted)
            }
        }
    })

    const handleSubmitted = async () => {
        await PaymentAccountService.updatePaymentAccount(props.merchant_id, {status : PAYMENT_ACCOUNT_STATUS.ONBOARDING})
        setIsSubmitted(true)
    }

    if(isSubmitted) {
        return <PaymentProcessingPage  redirectedFromSuccessfulSubmit={true}/>
    }

    return (
        <>
            <h3>
                <FormattedMessage
                    id="rainforest.merchant_onboarding.title"
                    defaultMessage="QuoteMachine Payments"
                /></h3>
            {/* @ts-ignore */}
            <rainforest-merchant-onboarding
                session-key={props.session_key}
                merchant-id={props.merchant_id}
                merchant-application-id={props.merchant_application_id}
                terms-and-conditions-url='https://www.quotemachine.com/en/payment-processing-agreement/'
                hide-merchant-mcc
            >
                {/* @ts-ignore */}
            </rainforest-merchant-onboarding>
        </>
    )
}

export default injectIntl(RainforestOnboardingMerchantWrapper)



// WEBPACK FOOTER //
// ./src/payment-processing/merchant-onboarding/RainforestMerchantOnboardingWrapper.tsx